import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import AnimateHeight from '@adsk/bim360-matrix-react-animate-height';
import {childrenType} from '../../constants/proptype-validation';

const AnimateHeightPopUp = ({className, isOpen, children}) => {
  const popUpClasses = cx('AnimateHeightPopUp', className);

  return (
    <AnimateHeight className={popUpClasses} isOpen={isOpen} height="0px" timeout={300}>
      {children}
    </AnimateHeight>
  );
};

AnimateHeightPopUp.displayName = 'AnimateHeightPopUp';

AnimateHeightPopUp.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  className: PropTypes.string,
  children: childrenType
};

export default AnimateHeightPopUp;
